export default __webpack_public_path__ + "static/media/star-2.6d04cfee.png";